/**
 * Handles weight/mass conversion calculations
 */
export class WeightConverter {
  /**
   * Round a number to 4 decimal places
   * @private
   */
  round(value) {
    return Math.round((value + 0.00001) * 10000) / 10000
  }

  /**
   * Convert a weight value to all supported units
   * @param {number} value - The weight value to convert
   * @param {string} fromUnit - The source unit (ounces, pounds, grams, kg, tons)
   * @returns {Object} Object containing all converted values
   */
  convertToAll(value, fromUnit) {
    const conversions = this.getConversionFactors(fromUnit)
    
    return {
      ounces: this.round(value * conversions.ounces),
      pounds: this.round(value * conversions.pounds),
      grams: this.round(value * conversions.grams),
      kg: this.round(value * conversions.kg),
      tons: this.round(value * conversions.tons)
    }
  }

  /**
   * Get conversion factors for a given source unit
   * @private
   */
  getConversionFactors(fromUnit) {
    const factors = {
      ounces: {
        ounces: 1,
        pounds: 0.0625,
        grams: 28.3495,
        kg: 0.0283495,
        tons: 0.00003125
      },
      pounds: {
        ounces: 16,
        pounds: 1,
        grams: 453.592,
        kg: 0.453592,
        tons: 0.0005
      },
      grams: {
        ounces: 0.035274,
        pounds: 0.00220462,
        grams: 1,
        kg: 0.001,
        tons: 1.102312499987599906e-6
      },
      kg: {
        ounces: 35.274,
        pounds: 2.20462,
        grams: 1000,
        kg: 1,
        tons: 0.00110231
      },
      tons: {
        ounces: 32000,
        pounds: 2000,
        grams: 907185,
        kg: 907.185,
        tons: 1
      }
    }

    return factors[fromUnit] || factors.ounces
  }

  /**
   * Get list of supported units
   * @returns {string[]} Array of supported unit names
   */
  getSupportedUnits() {
    return ['ounces', 'pounds', 'grams', 'kg', 'tons']
  }
}
